export default {
    data() {
        return {
            isSessionExpired: false,
            intervalCounter: null,
            count: 180,
        }
    },
    methods: {
        subscribeToEvents() {
            this.$eventBus.$on('session_expired:start_countdown', this.startCountDownToLogOut)
            this.$eventBus.$on('session_expired:continue_session', this.continueSession)
            this.$eventBus.$on('session_expired', this.sessionExpired)
        },
        sessionExpired() {
            this.isSessionExpired = true;
        },
        continueSession() {
            this.isSessionExpired = false;
            clearInterval(this.intervalCounter);
            this.intervalCounter = null;
            this.count = 1800;
        },
        startCountDownToLogOut() {
            this.isSessionExpired = true;
            this.intervalCounter = setInterval(() => {
                this.count--;
                if (this.count <= 0) {
                    this.count = 0;
                    clearInterval(this.intervalCounter);
                    this.logOut(
                        () => this.$store.dispatch('sessionExpired'),
                        () => this.$store.dispatch('sessionExpired')
                    )
                }
            }, 1000)
        },
    },
    mounted() {
        this.subscribeToEvents();
    },
    beforeDestroy() {
        this.$eventBus.$off('session_expired:start_countdown');
        this.$eventBus.$off('session_expired:continue_session');
        this.$eventBus.$off('session_expired');
    },
    onIdle() {
        this.$eventBus.$emit('session_expired:start_countdown');
    },
    onActive() {

        if (this.isSessionExpired) {
            this.$eventBus.$emit('session_expired');
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/sessionExpiredModal.js